
import Vue from 'vue';
import { Data as HeadlinesData, DataWithHref } from '@root/modules/headlines/types/headlines';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import HeadlineBlocks from '@root/common/components/base/headline/HeadlineBlocks.vue';

interface Methods {
  getHeadline: (headline: HeadlinesData) => DataWithHref;
  getTopHeadlines: () => void;
  getArticleHeadlines: (sectionId: string) => Promise<HeadlinesData[]>;
}

interface Data {
  data: Record<string, any>;
  domain: string;
  topHeadlines: HeadlinesData[];
  topHeadlinesLimit: number;
  sectionId?: string;
  settings: Record<string, any>;
}

interface Computed {
  showViews: boolean;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: {
    HeadlineBlocks,
  },
  data() {
    const { domain } = this.$channelConfig('settings');
    return {
      data: {
        items: [],
      },
      domain,
      topHeadlines: [],
      topHeadlinesLimit: 8,
      sectionId: this.$channelConfig('page').article.component.topHeadlines.sectionId,
      settings: {
        channel: false,
        lead: false,
        publishDate: false,
        author: false,
        titleComment: true,
        videoDuration: true,
      },
    };
  },
  computed: {
    showViews() {
      return this.$channelConfig('settings').showViews ?? false;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getTopHeadlines();
    });
  },
  methods: {
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domain, fakeDomainEnabled });
    },
    async getTopHeadlines() {
      const headlines = this.sectionId ? await this.getArticleHeadlines(this.sectionId) : [];
      if (headlines.length) {
        this.topHeadlines = headlines.map((headline) => this.getHeadline(headline)) || [];
      }
    },
    async getArticleHeadlines(sectionId) {
      const universalHeadlinesService = new UniversalHeadlinesService();
      const headlines = await universalHeadlinesService.fetch({ sectionId, limit: this.topHeadlinesLimit, getViews: true });
      return headlines.items;
    },
  },
});
